import { liveBattleActionTypes } from './Constants';

export function createLiveBattle(data) {
	return {
		type: liveBattleActionTypes.CREATE_LIVE_BATTLE,
		payload: {
			data,
		},
	};
}

export function createLiveBattleSuccess(data) {
	return {
		type: liveBattleActionTypes.CREATE_LIVE_BATTLE_SUCCESS,
		payload: {
			data,
		},
	};
}

export function createLiveBattleError() {
	return {
		type: liveBattleActionTypes.CREATE_LIVE_BATTLE_ERROR,
	};
}

export function getBattleRoomData(code, withRedirect) {
	return {
		type: liveBattleActionTypes.GET_BATTLE_ROOM_DATA,
		payload: {
			code,
			withRedirect,
		},
	};
}

export function getBattleRoomDataSuccess(data) {
	return {
		type: liveBattleActionTypes.GET_BATTLE_ROOM_DATA_SUCCESS,
		payload: {
			data,
		},
	};
}

export function getBattleRoomDataError(data) {
	return {
		type: liveBattleActionTypes.GET_BATTLE_ROOM_DATA_ERROR,
		payload: {
			data,
		},
	};
}

export function checkOutBattle(roomUserId, code) {
	return {
		type: liveBattleActionTypes.CHECK_OUT_BATTLE,
		payload: {
			roomUserId,
			code,
		},
	};
}

export function checkOutBattleSuccess(data) {
	return {
		type: liveBattleActionTypes.CHECK_OUT_BATTLE_SUCCESS,
		payload: {
			data,
		},
	};
}

export function checkOutBattleError() {
	return {
		type: liveBattleActionTypes.CHECK_OUT_BATTLE_ERROR,
	};
}

export function closeBattle(code) {
	return {
		type: liveBattleActionTypes.CLOSE_BATTLE,
		payload: {
			code,
		},
	};
}

export function closeBattleSuccess(data) {
	return {
		type: liveBattleActionTypes.CLOSE_BATTLE_SUCCESS,
		payload: {
			data,
		},
	};
}

export function closeBattleError() {
	return {
		type: liveBattleActionTypes.CLOSE_BATTLE_ERROR,
	};
}

export function changeBattleSettings(code, data, onlyLock) {
	return {
		type: liveBattleActionTypes.CHANGE_BATTLE_SETTINGS,
		payload: {
			code,
			data,
			onlyLock,
		},
	};
}

export function changeBattleSettingsSuccess(data) {
	return {
		type: liveBattleActionTypes.CHANGE_BATTLE_SETTINGS_SUCCESS,
		payload: {
			data,
		},
	};
}

export function changeBattleSettingsError() {
	return {
		type: liveBattleActionTypes.CHANGE_BATTLE_SETTINGS_ERROR,
	};
}

export function startBattle(code) {
	return {
		type: liveBattleActionTypes.START_BATTLE,
		payload: {
			code,
		},
	};
}

export function startBattleSuccess(data) {
	return {
		type: liveBattleActionTypes.START_BATTLE_SUCCESS,
		payload: {
			data,
		},
	};
}

export function startBattleError() {
	return {
		type: liveBattleActionTypes.START_BATTLE_ERROR,
	};
}

export function toggleCloseRoomModal(data) {
	return {
		type: liveBattleActionTypes.TOGGLE_CLOSE_ROOM_MODAL,
		payload: {
			data,
		},
	};
}

export function toggleRoomSettingsModal(data) {
	return {
		type: liveBattleActionTypes.TOGGLE_ROOM_SETTINGS_MODAL,
		payload: {
			data,
		},
	};
}

export function toggleContinuePracticingModal(data) {
	return {
		type: liveBattleActionTypes.TOGGLE_CONTINUE_PRACTICING_MODAL,
		payload: {
			data,
		},
	};
}

export function getAnswerResults(liveBattleRoomId) {
	return {
		type: liveBattleActionTypes.GET_ANSWER_RESULTS,
		payload: {
			liveBattleRoomId,
		},
	};
}

export function getAnswerResultsSuccess(answerResults) {
	return {
		type: liveBattleActionTypes.GET_ANSWER_RESULTS_SUCCESS,
		payload: {
			answerResults,
		},
	};
}

export function getAnswerResultsError() {
	return {
		type: liveBattleActionTypes.GET_ANSWER_RESULTS_ERROR,
	};
}

export function getQuestionAnswers(liveBattleRoomId, questionId) {
	return {
		type: liveBattleActionTypes.GET_QUESTION_ANSWERS,
		payload: {
			liveBattleRoomId,
			questionId,
		},
	};
}

export function getQuestionAnswersSuccess(questionAnswers, questionId) {
	return {
		type: liveBattleActionTypes.GET_QUESTION_ANSWERS_SUCCESS,
		payload: {
			questionAnswers,
			questionId,
		},
	};
}

export function getQuestionAnswersError(questionId) {
	return {
		type: liveBattleActionTypes.GET_QUESTION_ANSWERS_ERROR,
		payload: {
			questionId,
		},
	};
}

export function setLiveBattleAnswerSummary(answerSummary) {
	return {
		type: liveBattleActionTypes.SET_LIVE_BATTLE_ANSWER_SUMMARY,
		payload: {
			answerSummary,
		},
	};
}

export function goToNextScreen(code) {
	return {
		type: liveBattleActionTypes.GO_TO_NEXT_BATTLE_SCREEN,
		payload: {
			code,
		},
	};
}

export function goToNextScreenSuccess() {
	return {
		type: liveBattleActionTypes.GO_TO_NEXT_BATTLE_SCREEN_SUCCESS,
	};
}

export function goToNextScreenError() {
	return {
		type: liveBattleActionTypes.GO_TO_NEXT_BATTLE_SCREEN_ERROR,
	};
}

export function skipBattleQuestion(code) {
	return {
		type: liveBattleActionTypes.SKIP_BATTLE_QUESTION,
		payload: {
			code,
		},
	};
}

export function clearState() {
	return {
		type: liveBattleActionTypes.CLEAR_LIVE_BATTLE_STATE,
	};
}

export function clearRemainingTime() {
	return {
		type: liveBattleActionTypes.CLEAR_REMAINING_TIME,
	};
}

export function clearAnswerSummary() {
	return {
		type: liveBattleActionTypes.CLEAR_ANSWER_SUMMARY,
	};
}
